import { render, staticRenderFns } from "./BrandRanking.vue?vue&type=template&id=7b4b776f&scoped=true"
import script from "./BrandRanking.vue?vue&type=script&lang=js"
export * from "./BrandRanking.vue?vue&type=script&lang=js"
import style0 from "./BrandRanking.vue?vue&type=style&index=0&id=7b4b776f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b776f",
  null
  
)

export default component.exports